module.exports = __webpack_public_path__ + "img/video-avtar2.cc4cb898.png";